// extracted by mini-css-extract-plugin
export default {"header":"distributionResult_header__+PZFU"};